import { Text, useInfoModal, useRouter } from '@capsicum/common-web';
import { useWCPledgeDisclaimerModalTexts } from '@capsicum/features/world-championship-pledge/shared';

export const useWCPledgeDisclaimerModal = () => {
	const { buttonText, content, subtitle, title } = useWCPledgeDisclaimerModalTexts();
	const { showInfoModal } = useInfoModal();
	const { push } = useRouter();

	const openWCPledgeDisclaimerModal = () => {
		showInfoModal({
			buttonOnHandlers: {
				onPrimaryButtonHandler: () => {
					push('/locker-room-internationals/confirmation');
				}
			},
			buttonTexts: {
				primaryButtonText: buttonText
			},
			content: <Text variant="text3">{content}</Text>,
			image: 'chzSendConfirmation',
			isClosable: false,
			subtitle,
			testID: 'wcPledge-disclaimerModal',
			title,
			variant: 'alert'
		});
	};

	return {
		openWCPledgeDisclaimerModal
	};
};
